export default class Currency {
    constructor(json) {
        json = json || {};
        this.iso = json.iso || 'GBP';
    }

    displayAmount(amount) {
        const formatter = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: this.iso
        });

        return formatter.format(amount);
    }
}